<template>
    <div class="truckKeyboard mask" v-if="showKeyBoard" @click="closeKeyboard">
        <div
            class="keyboard-box"
            :class="{ 'safe-area-inset-bottom': safeAreaInset }"
            @click.stop="() => {}"
        >
            <div
                class="recently-use flex"
                v-if="isProvince && showRecently && recentlyUser.length"
            >
                <div>最近常用：</div>
                <div
                    v-for="(item, index) in recentlyUser"
                    :key="index"
                    class="recently-use-item"
                    @click="provinceChange(item)"
                >
                    {{ item }}
                </div>
            </div>
            <div class="keyboard-content">
                <div class="province flex" v-if="isProvince">
                    <div
                        class="province-name text-center"
                        v-for="item in province"
                        @click="provinceChange(item)"
                        :key="item"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="number-box" v-else>
                    <div
                        class="number-name flex flex-center flex-vertical-center"
                    >
                        <div
                            class="number text-center"
                            :class="{ disable: vclNo.length <= 1 }"
                            v-for="item in LetterNumber.Number"
                            @click="provinceChange(item)"
                            :key="item"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="letter-name flex">
                        <div
                            class="letter text-center"
                            v-for="item in LetterNumber.Letter"
                            @click="provinceChange(item)"
                            :key="item"
                        >
                            {{ item }}
                        </div>
                        <div
                            class="delete-btn flex flex-center flex-vertical-center"
                            @click="deletevclNo"
                        >
                            <img
                                src="../../assets/images/search/delete-icon.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="search-btn text-center" @click="searchBtn">
                            {{ searchTitle }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { province, LetterNumber } from '../../utils/truckkeyboard'
import ajax from '@/api/index'

export default {
    props: {
        vclNo: {
            // 车牌号
            type: String,
            default: ''
        },
        searchTitle: {
            type: String,
            default: '搜索'
        },
        showRecently: {
            // 是否显示最新常用省份
            type: Boolean,
            default: false
        },
        showKeyBoard: {
            // 显示键盘
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            province,
            LetterNumber,
            recentlyUser: []
        }
    },
    computed: {
        ...mapState({
            userInfo: 'userInfo'
        }),
        isProvince() {
            return this.vclNo === ''
        }
    },
    watch: {
        async showKeyBoard(value) {
            try {
                if (value && this.showRecently) {
                    const { code, data } = await ajax.getKeyBoardOftenProvince()
                    if (code === 200) {
                        this.recentlyUser = data
                    }
                }
            } catch (error) {
                // 错误信息
            }
        }
    },
    methods: {
        /**
         * 通知父组件点击的是那个数字字母
         *
         * @param item 用户点击键盘每次输入的值
         */
        provinceChange(item) {
            if (this.vclNo.length > 6) {
                return
            }
            if (LetterNumber.Number.indexOf(item) >= 0) {
                if (this.vclNo.length > 0 && this.vclNo.length < 2) {
                    const vclNo = this.vclNo + item
                    let flag = /[0-9]/.test(vclNo[1])
                    if (flag) {
                        return
                    }
                }
            }
            this.$emit('confirm', item)
        },

        /**
         * 删除车牌号的最后一位
         */
        deletevclNo() {
            this.$emit('on-delete')
        },

        /**
         * 通知父组件进行查询
         */
        searchBtn() {
            this.$emit('on-search')
        },
        closeKeyboard() {
            this.$emit('close')
        }
    },
    components: {}
}
</script>

<style scoped lang="scss">
.truckKeyboard {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vh;
    height: 100vh;
    .keyboard-box {
        width: 100vw;
        background-color: #d1d5db;
        min-height: 380px;
        position: absolute;
        left: 0;
        bottom: -100vh;
        z-index: 100;
        animation: upup 0.5s forwards;
    }
    .recently-use {
        background: #fff;
        padding: 20px 30px;
        align-items: center;
        :nth-child(1) {
            font-size: 28px;
            font-family: PingFang SC;
            color: rgba(0, 0, 0, 1);
        }
        .recently-use-item {
            font-size: 36px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 50px;
            color: rgba(0, 0, 0, 1);
            padding: 0 20px;
        }
    }
    .keyboard-content {
        padding: 10px 24px;
        .province {
            flex-wrap: wrap;
            .province-name {
                width: 70px;
                height: 70px;
                line-height: 70px;
                margin: 0 20px 20px 0;
                font-size: 28px;
                &:nth-of-type(8n + 8) {
                    margin-right: 0;
                }
            }
        }
        .number-box {
            .number-name {
                margin-top: 10px;
            }
            .number {
                flex: 1;
                margin: 8px;
                padding: 10px;
                color: #000000;
                border-radius: 10px;
            }
            .disable {
                color: #989898;
                &:active {
                    background-color: #fff;
                }
            }
        }
        .letter-name {
            box-sizing: border-box;
            flex-wrap: wrap;
            padding: 10px 0;
            .letter {
                width: 81.42px;
                margin: 4px;
                font-size: 28px;
                margin: 10px;
                height: 81.42px;
                line-height: 81.42px;
                :active {
                    background: #a9aeba;
                }
                &:nth-of-type(7n + 7) {
                    margin-right: 0;
                }
            }
            .search-btn {
                background-color: #5572fd;
                color: #fff;
                font-size: 36px;
                height: 81.42px;
                line-height: 81.42px;
                width: 180px;
                margin: 10px 0 0 6px;
            }
            .delete-btn {
                width: 192px;
                height: 81.42px;
                margin: 10px 6px 0 6px;
                background-color: #acb4be;
                img {
                    width: 30%;
                }
            }
            .delete-btn,
            .search-btn {
                border-radius: 10px;
            }
        }
        .letter,
        .number,
        .province-name {
            background-color: #fff;
            border-radius: 10px;
            font-weight: bold;
            &:active {
                background: #a9aeba;
            }
        }
        .delete,
        .search {
            &:active {
                background: #ffffff;
                color: #000;
            }
        }
    }
}
@keyframes upup {
    from {
        bottom: -100vh;
    }

    to {
        bottom: 0;
    }
}
</style>
